import React from 'react';
import Typography from '@src/new-components/Typography';
import EmptyVoiceImage from '@src/assets/images/empty-project.svg';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import sanitizeHtml from 'sanitize-html';
import CommonButton from '@src/new-components/Button';
import { AddRounded } from '@mui/icons-material';
import { StyledEmptyVoices } from './index.style';

const EmptyVoices = ({
  description,
  isDescription,
  onCreate,
  isCreate,
  createText,
}) => {
  const { t } = useTranslation();

  return (
    <StyledEmptyVoices>
      <img
        src={EmptyVoiceImage}
        alt="Empty box"
        className="empty-voice-image"
      />
      {isDescription && (
        <Typography
          variant="body-16-medium"
          sx={{ textAlign: 'center', color: COLOR.label2[64] }}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(t(description), {
              allowedTags: ['br'],
            }),
          }}
        />
      )}
      {isCreate && (
        <CommonButton
          variant="outlineSmall"
          textProps={{
            variantText: 'body-14-medium',
            color: COLOR.secondary[100],
          }}
          customStyle={{
            height: '40px',
          }}
          startIcon={<AddRounded />}
          onClick={onCreate}
        >
          <Typography variant="body-14-bold" color={COLOR.indigo.default}>
            {createText || t('createInstantVoice')}
          </Typography>
        </CommonButton>
      )}
    </StyledEmptyVoices>
  );
};

export default EmptyVoices;
